import _ from "lodash";
import { nameOf } from "./typescript";
import { InputObject } from "../controls/default";

export function hasValue(value: any) {
  if (_.isArray(value)) {
    return !!value.length;
  } else if (_.isObject(value) && nameOf<InputObject>("value") in value) {
    return true;
  } else if (typeof value == "string") {
    return !!value.length;
  } else if (typeof value == "number") {
    return true;
  } else if (typeof value == "boolean") {
    return true;
  } else if (_.isObject(value)) {
    return true;
  }

  return false;
}
